<template>
  <div class="mt-3">
    <div v-for="defect in pole.defects">
      <div :key="`container${defect._id}${defect.ilsas_verify}${defect.sesb_verify}${defect.inMaintenance}`">
        <!-- <div class="btn-verify-container mb-n3 pt-4 d-flex align-items-center" :key="`btnVerify${defect._id}`"
          :id="`btnVerify${defect._id}`" v-if="!filters.print">
          <p class="lead mb-0">
            <span class="badge badge-success badge-pill d-flex align-items-center mr-3">
              <span class="badge badge-dark badge-pill mr-2">1</span>
              <span class="font-weight-normal">OPERATOR</span>
            </span>
          </p>
          <p class="lead mb-0" v-if="
            !user ||
            user.company != 'ilsas' ||
            getDefectVerificationStatus(defect.ilsas_verify)
          ">
            <span class="badge badge-pill d-flex align-items-center mr-3 py-1" :class="{
              'badge-secondary': !getDefectVerificationStatus(
                defect.ilsas_verify
              ),
              'badge-success':
                getDefectVerificationStatus(defect.ilsas_verify) == 'true',
              'badge-danger':
                getDefectVerificationStatus(defect.ilsas_verify) ==
                'rejected',
            }">
              <span class="badge badge-dark badge-pill mr-2">2</span>
              <span class="font-weight-normal">ILSAS</span>
              <font-awesome-icon :icon="['fas', 'award']" class="ml-2" v-if="
                getDefectVerificationStatus(defect.ilsas_verify) == 'true'
              " />
              <font-awesome-icon :icon="['fas', 'question-circle']" class="ml-2 clickable"
                @click="viewRejectReason(defect.ilsas_verify)" title="Click to view reason" v-if="
                  getDefectVerificationStatus(defect.ilsas_verify) == 'rejected'
                " />
            </span>
          </p>
          <div class="dropdown" v-else-if="
            user &&
            user.company == 'ilsas' &&
            !getDefectVerificationStatus(defect.ilsas_verify)
          ">
            <button class="btn btn-secondary btn-sm rounded-pill dropdown-toggle mr-3 py-1" type="button"
              id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="badge badge-dark badge-pill mr-2">2</span>
              ILSAS
            </button>
            <div class="dropdown-menu shadow-lg" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item small" href="#" @click.prevent="verifyDefect('approve', defect)">
                <font-awesome-icon :icon="['fas', 'award']" class="mr-1" />Approve
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item small" href="#" @click.prevent="verifyDefect('reject', defect)">
                <font-awesome-icon :icon="['far', 'times-circle']" class="mr-1" />Reject
              </a>
            </div>
          </div>
          <p class="lead mb-0" v-if="
            !user ||
            user.company != 'sesb' ||
            getDefectVerificationStatus(defect.ilsas_verify) != 'true' ||
            getDefectVerificationStatus(defect.sesb_verify)
          ">
            <span class="badge badge-pill d-flex align-items-center mr-3 py-1" :class="{
              'badge-secondary': !getDefectVerificationStatus(
                defect.sesb_verify
              ),
              'badge-success':
                getDefectVerificationStatus(defect.sesb_verify) == 'true',
              'badge-danger':
                getDefectVerificationStatus(defect.sesb_verify) == 'rejected',
            }">
              <span class="badge badge-dark badge-pill mr-2">3</span>
              <span class="font-weight-normal">SESB</span>
              <font-awesome-icon :icon="['fas', 'award']" class="ml-2"
                v-if="getDefectVerificationStatus(defect.sesb_verify) == 'true'" />
              <font-awesome-icon :icon="['fas', 'question-circle']" class="ml-2 clickable"
                @click="viewRejectReason(defect.sesb_verify)" title="Click to view reason" v-if="
                  getDefectVerificationStatus(defect.sesb_verify) == 'rejected'
                " />
            </span>
          </p>
          <div class="dropdown" v-else-if="
            user &&
            user.company == 'sesb' &&
            getDefectVerificationStatus(defect.ilsas_verify) == 'true' &&
            !getDefectVerificationStatus(defect.sesb_verify)
          ">
            <button class="btn btn-secondary btn-sm rounded-pill dropdown-toggle mr-3 py-1" type="button"
              id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="badge badge-dark badge-pill mr-2">3</span>
              SESB
            </button>
            <div class="dropdown-menu shadow-lg" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item small" href="#" @click.prevent="verifyDefect('approve', defect)">
                <font-awesome-icon :icon="['fas', 'award']" class="mr-1" />Approve
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item small" href="#" @click.prevent="verifyDefect('reject', defect)">
                <font-awesome-icon :icon="['far', 'times-circle']" class="mr-1" />Reject
              </a>
            </div>
          </div>
          <div class="ml-auto badge badge-success badge-pill px-3 py-2 font-weight-normal" v-if="defect.userApprove">
            <font-awesome-icon :icon="['fas', 'check-circle']" class="mr-2" />Maintenance Approved
          </div>
          <button class="btn btn-sm rounded-pill ml-auto" :class="defect.inMaintenance ? 'btn-info' : 'btn-primary'"
            @click="addToMaintenance(defect)" v-else-if="
              user && user.company && user.company.toLowerCase() == 'sesb'
            ">
            <font-awesome-icon :icon="['fas', 'minus-circle']" class="mr-1" v-if="defect.inMaintenance" />
            <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-1" v-else />
            {{ defect.inMaintenance ? "Remove from" : "Add to" }} Maintenance
          </button>
        </div> -->
        <div :id="`sheet_${defect._id}`" class="report sheet border rounded" :key="defect._id">
          <article :class="{ transparent: isLoading }">
            <div class="sheet-header">
              <div class="header-logo">
                <img :src="district.custom_logo.url"
                  v-if="district && district.custom_logo && district.custom_logo.url" />
                <img src="@/assets/images/tnb-logo-report.png" v-else />
                <div class="header-title border-top">
                  {{ filters.type }} Report
                </div>
              </div>
              <div class="header-info border-left">
                <div class="info-table">
                  <div class="table-row border-bottom">
                    <div class="table-cell table-head border-right">
                      <p>SOURCE</p>
                    </div>
                    <div class="table-cell table-cell-long table-head border-right">
                      <p class="pl-1 text-uppercase">{{ source }}</p>
                    </div>
                  </div>
                  <div class="table-row border-bottom">
                    <div class="table-cell table-subhead border-right">
                      <p>POLE NO</p>
                    </div>
                    <div class="table-cell border-right">
                      <p>{{ pole.name }}</p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>DATE</p>
                    </div>
                    <div class="table-cell border-right">
                      <p>{{ dateFormat("date", pole.datetime) }}</p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>TIME</p>
                    </div>
                    <div class="table-cell">
                      <p>{{ dateFormat("time", pole.datetime) }}</p>
                    </div>
                  </div>
                  <div class="table-row border-bottom">
                    <div class="table-cell table-subhead border-right">
                      <p>POLE TYPE</p>
                    </div>
                    <div class="table-cell border-right">
                      <p>{{ pole.type }} {{ pole.structure_type }}</p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>VOLTAGE</p>
                    </div>
                    <div class="table-cell border-right">
                      <p>{{ voltage }} kV</p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>TEMP</p>
                    </div>
                    <div class="table-cell">
                      <p>{{ temperature ? `${temperature} °C` : "n/a" }}</p>
                    </div>
                  </div>
                  <div class="table-row border-bottom">
                    <div class="table-cell table-subhead border-right">
                      <p>LOAD</p>
                    </div>
                    <div class="table-cell border-right">
                      <p>{{ load ? `${load} A` : "UNKNOWN" }}</p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>PHASE</p>
                    </div>
                    <div class="table-cell border-right">
                      <p>{{ defect.phase || "UNKNOWN" }}</p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>HUMIDITY</p>
                    </div>
                    <div class="table-cell">
                      <p>{{ humidity ? `${humidity} %` : "n/a" }}</p>
                    </div>
                  </div>
                  <div class="table-row border-bottom">
                    <div class="table-cell table-subhead border-right">
                      <p>COORDINATE</p>
                    </div>
                    <div class="table-cell table-cell-long">
                      <p class="px-2">
                        {{ pole.lat ? pole.lat.toFixed(5) : "n/a" }},
                        {{ pole.lng ? pole.lng.toFixed(5) : "n/a" }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="sheet-components" :class="{ 'sheet-components-visual': defect.type == 'visual' }">
              <div class="component-table">
                <div class="table-row table-row-head border-bottom">
                  <div class="table-cell table-head text-center">
                    <p>COMPONENT / EQUIPMENT</p>
                  </div>
                </div>
                <template v-if="defect.type === 'visual' && pole.type == 'ABC'">
                  <div class="table-row border-bottom">
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("tiang", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>TIANG</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "no_tiang_/_notis_bahaya",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>NO. TIANG / NOTIS BAHAYA</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("rentis", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>RENTIS</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType("pengalir_fasa", defect.component)
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>PENGALIR FASA</p>
                    </div>
                  </div>
                  <div class="table-row border-bottom">
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("umbang", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>UMBANG</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType("penebat_umbang", defect.component)
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>PENEBAT UMBANG</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType("earth_bonding", defect.component)
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>EARTH BONDING</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType("tamatan_kabel", defect.component)
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>TAMATAN KABEL</p>
                    </div>
                  </div>
                  <div class="table-row border-bottom">
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("joint", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>JOINT</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("cable_tray", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>CABLE TRAY</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType("penangkap_kilat", defect.component)
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>PENANGKAP KILAT</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "switch_link_/_lbs_/_ar",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>SWITCH LINK / LBS / AR</p>
                    </div>
                  </div>
                  <div class="table-row border-bottom">
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "suspension_/_dead_end_clamp",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>SUSPENSION / DEAD END CLAMP</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "triangular_bracket",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>TRIANGULAR BRACKET</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("others", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>OTHERS</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("observations", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>OBSERVATIONS</p>
                    </div>
                  </div>
                </template>
                <template v-else-if="defect.type === 'visual' && pole.type != 'ABC'">
                  <div class="table-row-alt border-bottom">
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("tiang", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>TIANG</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "no_tiang_/_notis_bahaya",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>NO. TIANG / NOTIS BAHAYA</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("rentis", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>RENTIS</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType("pengalir_fasa", defect.component)
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>PENGALIR FASA</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("umbang", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>UMBANG</p>
                    </div>
                  </div>
                  <div class="table-row-alt border-bottom">
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "switch_link_/_lbs_/_ar",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>SWITCH LINK / LBS / AR</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "pepalang_(crossarm)",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>PEPALANG (CROSSARM)</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType("pengalir_bumi", defect.component)
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>PENGALIR BUMI</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "dawai_ke_bumi_(earth_wire)",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>DAWAI KE BUMI (EARTH WIRE)</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType("disc_insulator", defect.component)
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>DISC INSULATOR</p>
                    </div>
                  </div>
                  <div class="table-row-alt border-bottom">
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "perangkap_kilat_pada_talian",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>PERANGKAP KILAT PADA TALIAN</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("jumper", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>JUMPER</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "pg_clamps_/_connectors",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>PG CLAMPS / CONNECTORS</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "anti_climbing_device",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>ANTI CLIMBING DEVICE</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("arching_horn", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>ARCHING HORN</p>
                    </div>
                  </div>
                  <div class="table-row-alt border-bottom">
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("lfi", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>LFI</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType("earth_crossarm", defect.component)
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>EARTH CROSSARM</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("others", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>OTHERS</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("observations", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead border-right">
                      <p>OBSERVATIONS</p>
                    </div>
                    <div class="table-cell bg-gray"></div>
                    <div class="table-cell table-subhead border-right bg-gray"></div>
                  </div>
                </template>
                <template v-else-if="defect.type === 'thermal'">
                  <div class="table-row border-bottom table-row-thermal">
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType("pengalir_fasa", defect.component)
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead">
                      <p>PENGALIR FASA</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "switch_link_/_lbs_/_ar",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead">
                      <p>SWITCH LINK / LBS / AR</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "pengalir_bumi_(shield_wire)",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead">
                      <p>PENGALIR BUMI (SHIELD WIRE)</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "dawai_ke_bumi_(earth_wire)",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead">
                      <p>DAWAI KE BUMI (EARTH WIRE)</p>
                    </div>
                  </div>
                  <div class="table-row border-bottom table-row-thermal">
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "penangkap_kilat_pada_talian",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead">
                      <p>PENANGKAP KILAT PADA TALIAN</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("jumper", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead">
                      <p>JUMPER</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType(
                            "pg_clamps_/_connector",
                            defect.component
                          )
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead">
                      <p>PG CLAMPS / CONNECTOR</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("arching_horn", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead">
                      <p>ARCHING HORN</p>
                    </div>
                  </div>
                  <div class="table-row border-bottom table-row-thermal">
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType("earth_bonding", defect.component)
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead">
                      <p>EARTH BONDING</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{
                          getComponentType("tamatan_kabel", defect.component)
                        }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead">
                      <p>TAMATAN KABEL</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("joint", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead">
                      <p>JOINT</p>
                    </div>
                    <div class="table-cell border-right">
                      <p class="position-relative text-center font-weight-bold">
                        {{ getComponentType("others", defect.component) }}
                      </p>
                    </div>
                    <div class="table-cell table-subhead">
                      <p>OTHERS</p>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="sheet-images">
              <div class="images-table">
                <div class="table-row border-bottom">
                  <div class="table-cell table-head w-100">
                    <p class="text-center">DEFECT IMAGE</p>
                  </div>
                </div>
                <div class="table-row row-images border-bottom">
                  <div class="table-cell border-right text-center p-2">
                    <div class="embed-responsive embed-responsive-4by3">
                      <div class="embed-responsive-item text-center">
                        <img class="clickable" :src="getImageUrl(defect._id, defect.type, 0)" @click="
                          toggleModal(
                            'galleryViewer',
                            true,
                            defect._id,
                            defect.type,
                            0,
                            defect.recommendation
                          )
                          " v-if="getImageUrl(defect._id, defect.type, 0)" />
                      </div>
                    </div>
                  </div>
                  <div class="table-cell text-center p-2">
                    <div class="embed-responsive embed-responsive-4by3">
                      <div class="embed-responsive-item text-center">
                        <img class="clickable" :src="getImageUrl(defect._id, defect.type, 1)" @click="
                          toggleModal(
                            'galleryViewer',
                            true,
                            defect._id,
                            defect.type,
                            1,
                            defect.recommendation
                          )
                          " v-if="getImageUrl(defect._id, defect.type, 1)" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-row row-images border-bottom">
                  <div class="table-cell border-right text-center p-2">
                    <div class="embed-responsive embed-responsive-4by3">
                      <div class="embed-responsive-item text-center">
                        <img class="clickable" :src="getImageUrl(defect._id, defect.type, 2)" @click="
                          toggleModal(
                            'galleryViewer',
                            true,
                            defect._id,
                            defect.type,
                            2,
                            defect.recommendation
                          )
                          " v-if="getImageUrl(defect._id, defect.type, 2)" />
                      </div>
                    </div>
                  </div>
                  <div class="table-cell text-center p-2">
                    <div class="embed-responsive embed-responsive-4by3">
                      <div class="embed-responsive-item text-center">
                        <img class="clickable" :src="getImageUrl(defect._id, defect.type, 3)" @click="
                          toggleModal(
                            'galleryViewer',
                            true,
                            defect._id,
                            defect.type,
                            3,
                            defect.recommendation
                          )
                          " v-if="getImageUrl(defect._id, defect.type, 3)" />
                      </div>
                    </div>
                  </div>
                  <!-- <div class="table-cell text-center p-2">
                    <div class="embed-responsive embed-responsive-4by3"
                      v-if="defect.defectImages && defect.type === 'thermal'">
                      <div class="embed-responsive-item text-center">
                        <table class="table table-sm table-bordered first">
                          <tr>
                            <td class="bg-gray" colspan="2">Measurements</td>
                          </tr>
                          <tr v-if="defect.bx1">
                            <td>Bx1</td>
                            <td>{{ defect.bx1 }}</td>
                          </tr>
                          <tr v-if="defect.bx2">
                            <td>Bx2</td>
                            <td>{{ defect.bx2 }}</td>
                          </tr>
                          <tr v-if="defect.sp1">
                            <td>Sp1</td>
                            <td>{{ defect.sp1 }}</td>
                          </tr>
                          <tr v-if="defect.sp2">
                            <td>Sp2</td>
                            <td>{{ defect.sp2 }}</td>
                          </tr>
                          <tr v-if="defect.deltaT">
                            <td>Dt1</td>
                            <td>{{ defect.deltaT }}</td>
                          </tr>
                        </table>

                        <table class="table table-sm table-bordered mb-0">
                          <tr>
                            <td class="severity bg-gray">Severity</td>
                            <td class="severity bg-info low">Low</td>
                            <td class="severity bg-warning minor">Minor</td>
                            <td class="severity bg-danger critical">Critical</td>
                          </tr>
                          <tr>
                            <td class="severity bg-gray">AT</td>
                            <td class="severity">1 - 3.9</td>
                            <td class="severity">4 - 15</td>
                            <td class="severity">&gt; 15</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <div class="embed-responsive embed-responsive-4by3" v-else>
                      <div class="embed-responsive-item text-center">
                        <img class="clickable" :src="getImageUrl(defect._id, defect.type, 3)" @click="
                          toggleModal(
                            'galleryViewer',
                            true,
                            defect._id,
                            defect.type,
                            3,
                            defect.recommendation
                          )
                          " v-if="getImageUrl(defect._id, defect.type, 3)" />
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="sheet-remarks">
              <div class="remarks-table">
                <div class="table-row border-bottom">
                  <div class="table-cell w-100 text-center">
                    <p class="font-weight-bolder">
                      {{ defect.type.toUpperCase() }} DEFECT
                    </p>
                  </div>
                </div>
                <div class="table-row row-remarks border-bottom">
                  <div class="table-cell table-cell-long" :class="{
                    'w-100': defect.type == 'thermal',
                    'border-right': defect.type == 'visual',
                  }">
                    <p>{{ defect.remark || "No remarks" }}</p>
                  </div>
                  <div class="table-cell border-right p-0" v-if="defect.type === 'visual'">
                    <div class="inner-row border-bottom">
                      <div class="inner-cell border-right">
                        <p class="position-relative text-center font-weight-bold p-0">
                          {{
                            getComponentType(
                              "low",
                              defect.severity || defect.status,
                              "severity"
                            )
                          }}
                        </p>
                      </div>
                      <div class="inner-cell-long bg-info">
                        <p>Low</p>
                      </div>
                    </div>
                    <div class="inner-row border-bottom">
                      <div class="inner-cell border-right">
                        <p class="position-relative text-center font-weight-bold p-0">
                          {{
                            getComponentType(
                              "cautious",
                              defect.severity || defect.status,
                              "severity"
                            )
                          }}
                        </p>
                      </div>
                      <div class="inner-cell-long bg-warning">
                        <p>
                          {{
                            defect.severity == "cautious" ? "Cautious" : "Minor"
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="inner-row">
                      <div class="inner-cell border-right">
                        <p class="position-relative text-center font-weight-bold p-0">
                          {{
                            getComponentType(
                              "critical",
                              defect.severity || defect.status,
                              "severity"
                            )
                          }}
                        </p>
                      </div>
                      <div class="inner-cell-long bg-danger">
                        <p>Critical</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :class="`sheet-recommendations sheet-recommendations-${defect.type}-${pole.type.toLowerCase()}`">
              <div class="recommendations-table">
                <div class="table-row border-bottom">
                  <div class="table-cell w-100 text-center">
                    <p class="font-weight-bolder">
                      ANALYSIS &amp; RECOMMENDATION
                    </p>
                  </div>
                </div>
                <div class="table-row row-recommendations" :class="getRowClass(defect.severity || defect.status)">
                  <div class="table-cell w-100">
                    <p>{{ defect.recommendation || "None" }}</p>
                  </div>
                </div>
              </div>
            </div>
          </article>
          <loading-spinner class="loading-spinner-component" v-if="isLoading"></loading-spinner>
        </div>
        <!-- <div :key="`break-${defect._id}`" class="page-break"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api.js";
import moment from "moment";
import Swal from "sweetalert2";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "reportSheet",
  props: [
    "district",
    "source",
    "feeder",
    "category",
    "pole",
    "poleModel",
    "filters",
    "sheetType",
    "voltage",
    "load",
    "temperature",
    "humidity",
    "redisRoute",
  ],
  components: {
    "loading-spinner": LoadingSpinner,
  },
  data() {
    return {
      isLoading: false,
      defectImages: [],
      user: null,
      verifiers: ["ilsas", "sesb"],
      visualImages: [],
      thermalImages: [],
    };
  },
  watch: {
    "pole.defects": {
      async handler() {
        if (this.pole.defects.length > 0) {
          this.resizeSheet();
          await this.fetchDefectImages();
        }
      },
      immediate: true,
    },
  },
  methods: {
    addToMaintenance(defect) {
      Swal.fire({
        title: "<small>Are you sure?</small>",
        html: `<small>${defect.inMaintenance ? "Remove from" : "Add to"
          } maintenance list</small`,
        icon: "question",
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-primary btn-sm px-4",
          cancelButton: "btn btn-link btn-sm px-4",
          actions: "border-top pt-3 d-flex justify-content-between",
        },
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          this.$emit("isLoading", true);

          let body = {
            recache: true,
          };

          if (this.poleModel) {
            body["poleId"] = this.poleModel;
          }

          if (this.redisRoute) {
            body["redisRoute"] = "/".concat(this.redisRoute);
          }

          body.inMaintenance = !defect.inMaintenance;

          return API.put(`defects/addToMaintenance/${defect._id}`, body)
            .then((retVal) => {
              return retVal.data;
            })
            .catch((err) => {
              this.$emit("isLoading", false);
              console.error(err);
              Swal.showValidationMessage(`Request failed: ${err}`);
            });
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.value) {
          Swal.fire(
            "",
            `Defect ${defect.inMaintenance ? "removed from" : "added to"
            } maintenance`,
            "success"
          );
          this.$emit("defectVerified", result.value);
        }
      });
    },
    viewRejectReason(v) {
      Swal.fire({
        title: "<small class='text-danger'>Reason of Rejection</small>",
        html: `<small>${v.split("||")[1]}</small>`,
        confirmButtonText: "Close",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-link btn-sm px-4",
        },
      });
    },
    getDefectVerificationStatus(v) {
      if (v) {
        let vArray = v.split(":");
        return vArray[0] == "true" ? "true" : "rejected";
      } else {
        return false;
      }
    },
    verifyDefect(type, defect) {
      if (type == "approve") {
        Swal.fire({
          title: "<small class='text-success'>Confirm Defect</small>",
          html: `<small>Do you want to confirm this defect<br/><span class="font-weight-bold">"${defect.remark}"</span>?</small>`,
          icon: "question",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          buttonsStyling: false,
          reverseButtons: true,
          customClass: {
            confirmButton: "btn btn-success btn-sm px-4",
            cancelButton: "btn btn-link btn-sm px-4",
            actions: "border-top pt-3 d-flex justify-content-between",
          },
        }).then((result) => {
          if (result.value) {
            if (
              this.user &&
              this.user.company &&
              this.verifiers.includes(this.user.company.toLowerCase())
            ) {
              this.$emit("isLoading", true);

              let body = {
                recache: true,
              };

              if (this.poleModel) {
                body["poleId"] = this.poleModel;
              }

              if (this.redisRoute) {
                body["redisRoute"] = "/".concat(this.redisRoute);
              }

              body[`${this.user.company.toLowerCase()}_verify`] = "true";

              API.put(`defects/${defect._id}`, body)
                .then((retVal) => {
                  Swal.fire("Approved!", "This defect is verified", "success");
                  this.$emit("defectVerified", retVal.data);
                })
                .catch((err) => {
                  this.$emit("isLoading", false);
                  console.error(err);
                });
            }
          }
        });
      } else if (type == "reject") {
        Swal.fire({
          title: "<small class='text-danger'>Reject Defect</small>",
          html: `<small>Do you want to reject this defect<br/><span class="font-weight-bold">"${defect.remark}"</span>?</small>`,
          icon: "question",
          confirmButtonText: "Reject",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          buttonsStyling: false,
          reverseButtons: true,
          customClass: {
            confirmButton: "btn btn-danger btn-sm px-4",
            cancelButton: "btn btn-link btn-sm px-4",
            actions: "border-top pt-3 d-flex justify-content-between",
          },
        }).then((result) => {
          if (result.value) {
            if (
              this.user &&
              this.user.company &&
              this.verifiers.includes(this.user.company.toLowerCase())
            ) {
              Swal.fire({
                title: "<small>Reason of rejection</small>",
                html: "<small>Please state reason of rejection</small",
                icon: "question",
                confirmButtonText: "Reject",
                cancelButtonText: "Cancel",
                showCancelButton: true,
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                  confirmButton: "btn btn-danger btn-sm px-4",
                  cancelButton: "btn btn-link btn-sm px-4",
                  actions: "border-top pt-3 d-flex justify-content-between",
                },
                input: "textarea",
                inputAttributes: {
                  autocapitalize: "off",
                },
                showLoaderOnConfirm: true,
                preConfirm: (value) => {
                  this.$emit("isLoading", true);

                  let body = {
                    recache: true,
                  };

                  if (this.poleModel) {
                    body["poleId"] = this.poleModel;
                  }

                  if (this.redisRoute) {
                    body["redisRoute"] = "/".concat(this.redisRoute);
                  }

                  body[
                    `${this.user.company.toLowerCase()}_verify`
                  ] = `false||${value}`;
                  return API.put(`defects/${defect._id}`, body)
                    .then((retVal) => {
                      return retVal.data;
                    })
                    .catch((err) => {
                      this.$emit("isLoading", false);
                      console.error(err);
                      Swal.showValidationMessage(`Request failed: ${error}`);
                    });
                },
                allowOutsideClick: () => !Swal.isLoading(),
              }).then((result) => {
                if (result.value) {
                  Swal.fire("Rejected!", "This defect is rejected", "success");
                  this.$emit("defectVerified", result.value);
                }
              });
            }
          }
        });
      }
    },
    toggleModal(modalName, show, defectId, defectType, index, caption) {
      if (show) {
        if (
          modalName === "galleryViewer" &&
          this.getImageUrl(defectId, defectType, index)
        ) {
          let galleryImageIndex = index;
          let galleryImages = [
            this.getImageUrl(defectId, defectType, 0),
            this.getImageUrl(defectId, defectType, 1),
            this.getImageUrl(defectId, defectType, 2),
            this.getImageUrl(defectId, defectType, 3),
          ];

          this.$emit(
            "toggleModal",
            modalName,
            show,
            galleryImages,
            galleryImageIndex,
            caption
          );
        }
      }
    },
    getImageUrl(defectId, defectType, index) {
      if (
        this.defectImages.filter((di) => di._id == defectId).length &&
        this.defectImages.filter((di) => di._id == defectId)[0].defectImages
          .length > 0 &&
        index >= 0 &&
        index <
        this.defectImages.filter((di) => di._id == defectId)[0].defectImages
          .length
      ) {
        let imageUrl = this[`${defectType}Images`].filter(
          (i) => i.defectId == defectId
        )[index];

        if (imageUrl) {
          return imageUrl.url && imageUrl.url.substring(0, 4) == "http"
            ? imageUrl.url
            : "https://".concat(imageUrl.url);
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    async fetchDefectImages() {
      this.defectImages = this.pole.defects;

      this.visualImages = this.pole.defects
        .filter((d) => d.type == "visual")
        .map((d) => {
          let x = d.defectImages.map((i) => {
            i["defectId"] = d._id;
            return i;
          });
          return x;
        })
        .flat();

      this.thermalImages = this.pole.defects
        .filter((d) => d.type == "thermal")
        .map((d) => {
          let x = d.defectImages.map((i) => {
            i["defectId"] = d._id;
            return i;
          });
          return x;
        })
        .flat();

      this.visualImages.length > 0 &&
        this.visualImages.sort((a, b) => {
          let aName = a.name ? a.name.toLowerCase() : null;
          let bName = b.name ? b.name.toLowerCase() : null;

          return aName < bName ? -1 : 1;
        });

      this.visualImages.length > 0 &&
        this.thermalImages.sort((a, b) => {
          let aName = a.name.toLowerCase();
          let bName = b.name.toLowerCase();

          return aName < bName ? -1 : 1;
        });
    },
    getRowClass(severity) {
      switch (severity) {
        case "low":
          return "bg-info";
          break;
        case "cautious":
          return "bg-warning";
          break;
        case "minor":
          return "bg-warning";
          break;
        case "critical":
          return "bg-danger";
          break;
        default:
          return "bg-light";
          break;
      }
    },
    getComponentType(type, component, severity) {
      if (component) {
        if (typeof component === "object") {
          return component.includes(type) ? "X" : "";
        } else if (severity && severity.length > 1) {
          return (component == "minor" ? "cautious" : component) == type
            ? "X"
            : "";
        } else {
          return type
            .replace(/\//g, "_")
            .replace(/_/g, " ")
            .replace(/ /g, "")
            .toLowerCase() ==
            component.replace(/\//g, "").replace(/ /g, "").toLowerCase()
            ? "X"
            : "";
        }
      } else {
        return "";
      }
    },
    dateFormat(type, date) {
      if (date) {
        if (type === "date") {
          return moment.utc(date).format("DD/MM/YYYY");
        } else if (type === "time") {
          return moment.utc(date).format("h:mm A");
        } else {
          return date;
        }
      } else {
        return "";
      }
    },
    resizeSheet(skipTimeout) {
      this.isLoading = skipTimeout ? false : true;
      setTimeout(
        () => {
          for (let index = 0; index < this.pole.defects.length; index++) {
            const defect = this.pole.defects[index];
            let elementId = `#sheet_${defect._id}`;
            const sheet = $(elementId);
            const sheetWidth = sheet.width();
            sheet.height(sheetWidth * 1.2414285714);
            sheet.css({
              fontSize: sheetWidth * 0.01026119403,
            });
            const title = sheet
              .children()
              .children()
              .children()
              .children(".header-title");
            title.css({
              fontSize: sheetWidth * 0.01679104478,
            });
          }
          this.isLoading = false;
        },
        skipTimeout ? 10 : 2000
      );
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    $(window).on("resize", (e) => {
      this.resizeSheet(true);
    });
  },
  beforeDestroy() {
    $(window).off("resize");
  },
};
</script>

<style lang="scss" scoped>
@import url("../assets/css/print.scss");

.bg-gray {
  background-color: #f5f7fa !important;
}

.sheet {
  width: 100% !important;
  height: auto;
  position: relative;

  article {
    width: 100%;
    height: 100%;
    display: block;

    &.transparent {
      opacity: 0;
    }

    .sheet-header {
      height: 10%;

      .header-logo {
        display: inline-block;
        vertical-align: top;
        width: 20%;
        height: 100%;
        position: relative;
        text-align: center;

        img {
          width: 95%;
          height: 73%;
          padding: 5px;
          object-fit: contain;
        }

        .header-title {
          height: 27%;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 600;
          text-transform: uppercase;
        }
      }

      .header-info {
        display: inline-block;
        vertical-align: top;
        width: 80%;
        height: 100%;

        .info-table {
          width: 100%;
          height: 100%;

          .table-row {
            height: 20%;

            .table-cell {
              width: 16.666666667%;

              &.table-cell-long {
                width: 83.333333333%;
              }
            }
          }
        }
      }
    }

    .sheet-components {
      height: 8%;

      &.sheet-components-visual {
        height: 10%;

        .table-row {
          &.table-row-head {
            height: 25% !important;
          }
        }
      }

      .component-table {
        width: 100%;
        height: 100%;

        // .table-row {
        //   height: 30%;

        //   &.table-row-thermal {
        //     height: 23.333333333%;
        //   }

        //   .table-cell {
        //     width: 5%;

        //     &.table-head {
        //       width: 100%;
        //     }

        //     &.table-subhead {
        //       width: 20%;
        //     }
        //   }
        // }

        .table-row {
          height: 18.75%;

          &.table-row-head {
            height: 30%;
          }

          &.table-row-thermal {
            height: 23.333333333%;
          }

          .table-cell {
            width: 5%;

            &.table-head {
              width: 100%;
            }

            &.table-subhead {
              width: 20%;
            }
          }
        }

        .table-row-alt {
          height: 20%;

          &.table-row-thermal {
            height: 23.333333333%;
          }

          .table-cell {
            width: 3%;

            &.table-head {
              width: 100%;
            }

            &.table-subhead {
              width: 17%;
            }
          }
        }
      }
    }

    .sheet-images {
      height: 63.5%;

      .images-table {
        width: 100%;
        height: 100%;

        .table-row {
          height: 4%;

          &.row-images {
            height: fit-content;
          }

          .table-cell {
            width: 50%;
          }
        }
      }
    }

    .sheet-remarks {
      height: 9%;

      .remarks-table {
        width: 100%;
        height: 100%;

        .table-row {
          height: 25%;

          &.row-remarks {
            height: 75%;
          }

          .table-cell {
            width: 20%;

            &.table-cell-long {
              width: 80%;
            }

            .inner-row {
              width: 100%;
              height: 33.5%;
              position: relative;

              &:nth-child(odd) {
                height: 33.25%;
              }

              .inner-cell {
                position: relative;
                display: inline-block;
                vertical-align: top;
                height: 100%;
                width: 25%;

                p {
                  margin: 0;
                  position: absolute;
                  top: 50%;
                  left: 0;
                  transform: translate(10%, -50%);
                  line-height: 110%;
                  width: 100%;
                  padding: 0px 3%;
                }
              }

              .inner-cell-long {
                position: relative;
                display: inline-block;
                vertical-align: top;
                height: 100%;
                width: 75%;

                p {
                  margin: 0;
                  position: absolute;
                  top: 50%;
                  left: 0;
                  transform: translate(10%, -50%);
                  line-height: 110%;
                  width: 100%;
                  padding: 0px 3%;
                }
              }
            }
          }
        }
      }
    }

    .sheet-recommendations {
      height: 9.5%;

      .recommendations-table {
        width: 100%;
        height: 100%;

        .table-row {
          height: 25%;

          &.row-recommendations {
            height: 75%;
          }
        }
      }

      &.sheet-recommendations-visual-abc {
        height: 7.5%;

        .recommendations-table {
          .table-row {
            height: 30%;

            &.row-recommendations {
              height: 70%;
            }
          }
        }
      }
    }

    .table-cell {
      position: relative;
      display: inline-block;
      vertical-align: top;
      padding: 0px 1%;
      height: 100%;

      p {
        margin: 0;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
        line-height: 110%;
        width: 100%;
        padding: 0px 3%;
      }

      img {
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        display: block;
        object-fit: contain;
      }
    }

    .table-head {
      color: #ffffff;
      background-color: #004c9c;
      font-weight: 500;
    }

    .table-subhead {
      background-color: #bdd7ee;
    }
  }
}
</style>
